import { generateQuestionURL } from './generateQuestionURL';

export function generateQuestionsByAreasOfImprovementURL(
  activityInstanceId: number
) {
  const url = generateQuestionURL();
  url.pathname += `${activityInstanceId}/insights`;
  return url;
}
